import instance from "@/services/api";

export const employeeTasksAPI = {
  async read(params = {}) {
    return await instance()
      .get("/common/employee_tasks/read/", { params })
      .then((res) => res?.data);
  },

  async setIsDone(body) {
    return await instance()
      .post("/common/employee_tasks/set_is_done/", body)
      .then((res) => res?.data);
  },
  async readSchemaId(params = {}) {
    return await instance(true, null, {showToast: false})
      .get("/project/wcheck_bpmn/schema-id/read/", {
        params,
      })
      .then((res) => res?.data);
  },
};
